// @ts-expect-error bender-url not typed
import appleStoreLogo from 'bender-url!../../images/icons/apple-store.png'; // @ts-expect-error bender-url not typed

import googlePlayStoreLogo from 'bender-url!../../images/icons/google-play-store.png'; // @ts-expect-error bender-url not typed

import gmailLogo from 'bender-url!../../images/icons/icon-gmail.svg'; // @ts-expect-error bender-url not typed

import yahooLogo from 'bender-url!../../images/icons/icon-yahoo.svg';
import { EmailClient } from '../step-check-your-email/emailUtils';
export let StoreKey;

(function (StoreKey) {
  StoreKey["Apple"] = "apple";
  StoreKey["GooglePlay"] = "googlePlay";
})(StoreKey || (StoreKey = {}));

const LogoImage = {
  [StoreKey.Apple]: appleStoreLogo,
  [StoreKey.GooglePlay]: googlePlayStoreLogo,
  [EmailClient.Gmail]: gmailLogo,
  [EmailClient.Yahoo]: yahooLogo
};
export default {
  get(key) {
    this.preload(key);
    return key && LogoImage[key] ? LogoImage[key] : LogoImage;
  },

  preload: key => {
    const image = LogoImage[key];
    const preloadedImage = new Image();
    preloadedImage.src = image;
    return preloadedImage;
  }
};